module.exports = __webpack_public_path__ + "img/promo_podveska.93a500c0.png";